export const PIN_LENGTH = 4;

export const LIGHT = 'light';
export const DARK = 'dark';

export const PIN_STATUS = {
  error: 'error',
  initial: 'initial',
  confirm: 'confirm',
  enter: 'enter',
};
